import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onChange", "ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex } from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import { formatDataTestId } from '../../../utils/formatters';
import FormError from '../FormError';
import Dropdown from './../../Dropdown';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FormDropdown(_ref) {
  var control = _ref.control,
    formField = _ref.formField,
    errors = _ref.errors,
    handleSetValue = _ref.handleSetValue,
    onChangeAction = _ref.onChangeAction;
  return _jsxs(Flex, _objectSpread(_objectSpread({
    direction: "column"
  }, _objectSpread(_objectSpread({}, defaultStyles), formField.styles)), {}, {
    "data-testid": formField.testid,
    "data-fieldname": formField.name,
    children: [_jsx(Controller, {
      name: formField.name,
      control: control,
      render: _ref2 => {
        var _errors$formField$nam, _formField$props, _formField$props2, _formField$props3;
        var field = _ref2.field;
        var _onChange = field.onChange,
          _ = field.ref,
          extraPropsField = _objectWithoutProperties(field, _excluded);
        var hasError = Boolean(errors === null || errors === void 0 || (_errors$formField$nam = errors[formField.name]) === null || _errors$formField$nam === void 0 ? void 0 : _errors$formField$nam.message);
        return _jsx(Dropdown, _objectSpread(_objectSpread(_objectSpread({}, formField.props), extraPropsField), {}, {
          onChange: o => {
            var _formField$onChange;
            (_formField$onChange = formField.onChange) === null || _formField$onChange === void 0 || _formField$onChange.call(formField, o === null || o === void 0 ? void 0 : o.id);
            _onChange(o === null || o === void 0 ? void 0 : o.id);
            onChangeAction === null || onChangeAction === void 0 || onChangeAction(o === null || o === void 0 ? void 0 : o.id, handleSetValue);
          },
          options: formField.dropdownOptions,
          label: formField.label,
          matchWidth: true,
          hasError: hasError,
          dataTestId: formatDataTestId(formField.testid, 'InnerDropdown'),
          selectedId: field.value ? field.value : field.name,
          dropdownStyles: _objectSpread(_objectSpread({}, (_formField$props = formField.props) === null || _formField$props === void 0 ? void 0 : _formField$props.dropdownStyles), {}, {
            menuListStyles: _objectSpread(_objectSpread({}, (_formField$props2 = formField.props) === null || _formField$props2 === void 0 || (_formField$props2 = _formField$props2.dropdownStyles) === null || _formField$props2 === void 0 ? void 0 : _formField$props2.menuListStyles), {}, {
              zIndex: 999
            }),
            menuButtonStyles: _objectSpread(_objectSpread({}, (_formField$props3 = formField.props) === null || _formField$props3 === void 0 || (_formField$props3 = _formField$props3.dropdownStyles) === null || _formField$props3 === void 0 ? void 0 : _formField$props3.menuButtonStyles), hasError && {
              border: '2px solid var(--chakra-colors-error)',
              borderColor: 'var(--chakra-colors-error) !important',
              _focus: {
                border: '2px solid var(--chakra-colors-error)'
              },
              _hover: {
                border: '2px solid var(--chakra-colors-error)',
                borderColor: 'var(--chakra-colors-error)'
              }
            })
          })
        }));
      }
    }), _jsx(FormError, {
      errors: errors,
      name: formField.name,
      extraStyles: formField.errorStyles
    })]
  }));
}
var defaultStyles = {
  marginBottom: 'var(--chakra-space-md)'
};